/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

// `.env.ts` is generated by the `npm run env` command
import { env } from './.env';

export const environment = {
  production: false,
  serviceWorker: false,
  version: env.npm_package_version,
  serverUrl: 'https://api-dev.gofair.co/',
  oauth: {
    grant_type: 'password',
    client_id: '2',
    client_secret: 'VIoxjOjuppOPXxH0rVrEZsOSQYK5yW7hLY4QPsrg',
  },
  websockets: {
    broadcaster: 'pusher',
    key: '24d55be4efd2e2591712',
    wsHost: 'api-dev.gofair.co',
    httpHost: 'api-dev.gofair.co',
    authEndpoint: 'https://api-dev.gofair.co/broadcasting/auth',
    wsPort: 6001,
    wssPort: 6001,
    forceTLS: true,
  },
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US'],
  kendoGridPageSizes: [15, 30, 50, 100, 250, 500],
  pipeDateFormat: 'dd.MM.yyyy',
  apiPipeDateFormat: 'YYYY-MM-DD',
  momentDateFormat: 'DD.MM.YYYY',
  apiPipeDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
  momentDateTimeFormat: 'DD.MM.YYYY HH:mm',
  pipeDateTimeFormat: 'dd.MM.yyyy HH:mm',

  enums: {
    types: {
      saleClientOffer: 176,
      saleGeneral: 177,
      saleWebOffers: 178,
      saleInvoices: 179,
      saleVouchers: 180,
      saleFeedback: 181,
      saleSendTerms: 185,
      saleWebOfferLinkCreate: 186,
      commentNote: 76,
      onlineBookingTerms: 248,
      saleAutoCampaign: 275,
    },
    roles: {
      administrator: 1,
      salesManager: 2,
      reservationManager: 3,
      customerCareManager: 4,
      financeManager: 5,
      contractingManager: 6,
      salesAgent: 7,
      reservationAgent: 8,
      customerCareAgent: 9,
      financeAgent: 10,
      contractingAgent: 11,
      amendmentAgent: 20,
      leadGeneration: 12,
      accountant: 13,
      marketing: 14,
      it: 15,
      externalPartner: 18,
      externalPartnerLead: 19,
    },
    companies: {
      t2f: 4,
      gf: 2,
      tft: 3,
      geta: 1,
      fresh: 10,
    },
  },
};
